// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__fjh27","Header__link":"Header_Header__link__jthm5","Header__logo":"Header_Header__logo__ELQ11"};